webpackJsonp([3],{

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(241);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3b213f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(257);
function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3b213f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "form{overflow:auto!important;padding:4em 2em;display:grid;grid-gap:2em;grid-template-columns:minmax(auto,500px);align-items:start;align-content:start;justify-content:center}form label{display:grid;grid-gap:1em;grid-auto-flow:row-reverse}form label span{font-weight:700;text-transform:uppercase;letter-spacing:2px;color:rgba(0,0,0,.6);order:0}form label input,form label input:valid{order:1;padding:1em;font-size:1.3em;border:0;outline:4px solid rgba(0,0,0,.2);border-radius:0;width:100%}form label input:focus,form label input:focus:invalid{outline-color:var(--primary-colour)}form label input:focus+span,form label input:focus:invalid+span{color:var(--primary-colour);transition:all .4s}form.submitted label input:invalid{outline-color:red}form.submitted label input:invalid+span{color:red}form a{background-color:var(--primary-colour);color:#fff;font-weight:700;padding:.7em 1.5em;border-radius:100px;display:grid;grid-gap:1em;grid-template-columns:1fr auto;align-items:center;justify-self:start;font-size:1.2em}form a:hover{background-color:var(--primary-colour-hover);transition:all .4s}@keyframes fadeIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}form .error{color:#fff;border:4px solid rgba(0,0,0,.4);padding:1em;display:grid;grid-template-columns:auto 1fr;grid-gap:1em;align-items:start;align-content:start;animation:.4s fadeIn}form .error i{color:red}form .error span{padding-top:.2em}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/assets/landing.css"],"names":[],"mappings":"AAAA,KACE,wBAA0B,AAC1B,gBAAiB,AAEjB,aAAc,AACd,aAAc,AACd,yCAA2C,AAC3C,kBAAmB,AACnB,oBAAqB,AACrB,sBAAwB,CACzB,AAED,WACE,aAAc,AACd,aAAc,AACd,0BAA4B,CAC7B,AAED,gBACE,gBAAkB,AAClB,yBAA0B,AAC1B,mBAAoB,AACpB,qBAA0B,AAC1B,OAAS,CACV,AAED,wCAEE,QAAS,AAET,YAAa,AACb,gBAAiB,AACjB,SAAU,AACV,iCAAsC,AACtC,gBAAiB,AACjB,UAAY,CACb,AAED,sDAEE,mCAAqC,CACtC,AAED,gEAEE,4BAA6B,AAC7B,kBAAqB,CACtB,AAED,mCACE,iBAAmB,CACpB,AACD,wCACE,SAAW,CACZ,AAED,OACE,uCAAwC,AACxC,WAAa,AACb,gBAAkB,AAClB,mBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,+BAAgC,AAChC,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CAClB,AAED,aACE,6CAA8C,AAC9C,kBAAqB,CACtB,AAED,kBACE,GACE,UAAW,AACX,mBAAsB,CACvB,AACD,GACE,UAAW,AACX,kBAAoB,CACrB,CACF,AAED,YACE,WAAa,AACb,gCAAqC,AACrC,YAAa,AAEb,aAAc,AACd,+BAAgC,AAChC,aAAc,AACd,kBAAmB,AACnB,oBAAqB,AACrB,oBAAuB,CACxB,AACD,cACE,SAAW,CACZ,AAED,iBACE,gBAAmB,CACpB","file":"landing.css","sourcesContent":["form {\n  overflow: auto !important;\n  padding: 4em 2em;\n\n  display: grid;\n  grid-gap: 2em;\n  grid-template-columns: minmax(auto, 500px);\n  align-items: start;\n  align-content: start;\n  justify-content: center;\n}\n\nform label {\n  display: grid;\n  grid-gap: 1em;\n  grid-auto-flow: row-reverse;\n}\n\nform label span {\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: rgba(0, 0, 0, 0.6);\n  order: 0;\n}\n\nform label input,\nform label input:valid {\n  order: 1;\n  border: 0;\n  padding: 1em;\n  font-size: 1.3em;\n  border: 0;\n  outline: 4px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  width: 100%;\n}\n\nform label input:focus,\nform label input:focus:invalid {\n  outline-color: var(--primary-colour);\n}\n\nform label input:focus + span,\nform label input:focus:invalid + span {\n  color: var(--primary-colour);\n  transition: 0.4s all;\n}\n\nform.submitted label input:invalid {\n  outline-color: red;\n}\nform.submitted label input:invalid + span {\n  color: red;\n}\n\nform a {\n  background-color: var(--primary-colour);\n  color: white;\n  font-weight: bold;\n  padding: 0.7em 1.5em;\n  border-radius: 100px;\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  justify-self: start;\n  font-size: 1.2em;\n}\n\nform a:hover {\n  background-color: var(--primary-colour-hover);\n  transition: 0.4s all;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\nform .error {\n  color: white;\n  border: 4px solid rgba(0, 0, 0, 0.4);\n  padding: 1em;\n\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 1em;\n  align-items: start;\n  align-content: start;\n  animation: 0.4s fadeIn;\n}\nform .error i {\n  color: red;\n}\n\nform .error span {\n  padding-top: 0.2em;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutations__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginForm',
  data: function data() {
    return {
      email: '',
      password: '',
      error: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setPageLoading']), {
    login: function login() {
      var _this = this;

      if (!this.$el.checkValidity() || !this.validate()) {
        this.$el.classList.add('submitted');
        return;
      }

      this.$auth.login({ data: {
          email: this.email,
          password: this.password
        } }).then(function (res) {
        _this.setPageLoading(true);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutations__["a" /* AUTHENTICATE_USER */], res);
      }).catch(function (err) {
        switch (err.response.status) {
          case 401:
          case 403:
            _this.error = 'Sorry, those details weren\'t recognised';
            break;
          default:
            _this.error = 'Sorry, something went wrong. Please check your internet connection and try again';
        }
      });
    },
    validate: function validate() {
      if (this.email.length === 0) {
        this.error = 'Please enter an email address.';
        return false;
      }
      if (this.password.length === 0) {
        this.error = 'Please enter a password.';
        return false;
      }
      return true;
    }
  })
});

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("7d78d677", content, true, {});

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports
exports.i(__webpack_require__(220), "");

// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Login.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('h1',[_vm._v("Log in")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"material-icons"},[_vm._v("error")]),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","name":"email","placeholder":"Email","required":"required"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("Email")])]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","name":"password","placeholder":"Password","required":"required"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("Password")])]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_c('span',[_vm._v("Log in")]),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("lock")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.fd73da88a57e9bda2636.js